import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { ShippmentsReportVM } from '../../Structure/ViewModels/Admin/ShippmentsReportVM'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { Container } from 'react-bootstrap'
import Search from '../Utilities/Search'
import CustomSelect from '../Utilities/CustomSelect'
import { JsxElement } from 'typescript'
import Control from 'react-select/dist/declarations/src/components/Control'
import { Globals } from '../../Structure/Globals/GlobalObs'

const ShippmentsReport = () => {
  const control = useVM<ShippmentsReportVM>(new ShippmentsReportVM())
  useEffect(()=>{control.getData()},[])

  useEffect(() => {
    const handleScrollPaths = () => {
        
        const elementPaths = scrollableRef.current;
        if (elementPaths) {
            const isNearBottom = elementPaths.scrollTop + elementPaths.clientHeight + 10 >= elementPaths.scrollHeight;
            if (isNearBottom) {
                control.getMore();
            }
        }
    };

    const element = scrollableRef.current;
    if (element) {
        element.addEventListener('scroll', handleScrollPaths);
    }

    return () => {
        if (element) {
            element.removeEventListener('scroll', handleScrollPaths);
        }
    };
}, [control.Data]);

const scrollableRef = useRef<HTMLTableElement | null>(null);

  return (
    <Container>
      <div className='py-3'>
        <div className='d-flex py-2'>
          <div>
            <Search hasNoSelect onSearch={a=>{ control.Search = a; control.getData() }} />
          </div>
          <div>
            <CustomSelect 
            list={[{label:'تم التسليم' , value:'done'} , {label:'لم يتم التسليم', value:'waiting'}]}
            clearable
            onSelect={(a)=>{ control.IsDone = a=='done'?'done':a=='waiting'?'waiting':'';  control.getData()}}
            onClear={()=>{ control.IsDone ='';  control.getData()}}
            />
          </div>
        </div>
        {
          control.Show(
            <div  ref={scrollableRef} className='overflow-x-auto' style={{ maxHeight:'70vh' }}>
            <table  ref={scrollableRef} className=' w-100 text-center' style={{minWidth:'500px'}}>
              <thead style={{ position:'sticky' }}>
                <tr className='txt-color-I bg-light-gray'>
                    <th>العميل</th>
                    <th>الموبايل</th>
                    <th>رقم الشحنة</th>
                    <th>الملاحظات</th>  
                    <th>الحالة</th>
                </tr>
              </thead>
              <tbody className='w-100'>
                {
                control.Data.map((item,index)=>(
                    <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                        <td className='text-center'>{item.trainee.arabic_name}</td>
                        <td className='text-center' style={{ direction:'ltr' }}>
                          {
                            Globals.auth.User?.permissions.some(a=>a.id=='21')?(`+${item.trainee.dial_code} ${item.trainee.mobile}`):(`-----`)
                          }  
                        </td>
                        <td className='text-center'>{item.shipment_number}</td>
                        <td className='text-center' style={{ maxWidth:'300px' }}>
                          {
                              (() => {
                                const Comp = () => {
                                  const [edited, setEdited] = useState(false)
                                  const [value, setValue] = useState(item.notes)

                                  return (
                                  <div className='d-flex w-100 px-3'>
                                    <textarea 
                                      style={{ resize:'none' }}
                                      className='input-field h-auto w-100' 
                                      value={value}
                                      onChange={a=>{
                                        setValue(a.target.value)
                                        setEdited(true)
                                      }}
                                      />
                                      {
                                        edited?(
                                          <div 
                                            className=' material-symbols-outlined my-auto px-3  text-success c-pointer'
                                            onClick={()=>{
                                              setEdited(false)
                                              control.saveNotes(item.id,value,()=>setEdited(true))
                                            }}
                                            >
                                            save
                                          </div>
                                          ):(null)
                                      }

                                  </div>);
                                }
                                return <Comp />;
                              })()
                          }
                          

                        </td>
                        <td className='text-center'>{item.status=='done'?item.status:(<button className='button-II bg-success text-white px-3 py-1' onClick={()=>control.recieved(item.id)}>تسليم</button>)}</td>
                    </tr>
                ))
                }
              </tbody>

            </table>
          </div>
          )
        }
      </div>
    </Container>
  )
}

export default ShippmentsReport
